export default function (app) {
	app.factory('LogoutInterceptorService', ['$q', $q => {

		const InterceptorServiceFactory = {};

		InterceptorServiceFactory.responseError = rejection => {
			if (rejection.status === 401 && window.location.pathname !== '/login') {
				window.location.href = '/login';
			}
			return $q.reject(rejection);
		};

		return InterceptorServiceFactory;

	}]);

	app.config(['$httpProvider', $httpProvider => {
		$httpProvider.interceptors.push('LogoutInterceptorService');
	}]);
}
